import React from "react";
import { usePortalAuth } from "../../auth/PortalAuthContext";
import { usePortalReceivables } from "../../api/portal";
import { StatusTag } from "../../components/StatusTag";
import { formatBRL, formatDate } from "../../utils/money";

export default function PortalDashboard() {
  const { account } = usePortalAuth();
  const { data: receivables, isLoading } = usePortalReceivables();

  const emAberto = (receivables ?? []).filter((r) => r.status === "EM_ABERTO");
  const vencidos = (receivables ?? []).filter((r) => r.status === "VENCIDO");
  const totalEmAberto = [...emAberto, ...vencidos].reduce((acc, r) => acc + Number(r.value), 0);

  return (
    <div className="d-flex flex-column gap-4">
      <div>
        <h4 className="mb-1" style={{ fontWeight: 400 }}>
          Olá, {account?.customer.razaoSocial}
        </h4>
        <p className="text-secondary mb-0" style={{ fontSize: "0.85rem" }}>
          Acompanhe seus títulos e a situação da sua assinatura aqui.
        </p>
      </div>

      <div className="row g-3">
        <div className="col-12 col-md-4">
          <div className="nt-card p-3 text-center">
            <div style={{ fontSize: "0.8rem", fontWeight: 700, color: "var(--sp-text-label)", textTransform: "uppercase" }}>
              Em aberto
            </div>
            <div className="nt-tabular" style={{ fontSize: "1.4rem" }}>
              {emAberto.length}
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4">
          <div className="nt-card p-3 text-center">
            <div style={{ fontSize: "0.8rem", fontWeight: 700, color: "var(--sp-text-label)", textTransform: "uppercase" }}>
              Vencidos
            </div>
            <div className="nt-tabular" style={{ fontSize: "1.4rem" }}>
              {vencidos.length}
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4">
          <div className="nt-card p-3 text-center">
            <div style={{ fontSize: "0.8rem", fontWeight: 700, color: "var(--sp-text-label)", textTransform: "uppercase" }}>
              Total pendente
            </div>
            <div className="nt-tabular" style={{ fontSize: "1.4rem" }}>
              {formatBRL(totalEmAberto)}
            </div>
          </div>
        </div>
      </div>

      <div className="nt-card p-3">
        <h6 className="mb-3 pb-2" style={{ borderBottom: "1px solid var(--color-divider)", fontWeight: 700 }}>
          Títulos
        </h6>
        {isLoading && <div className="text-secondary">Carregando…</div>}
        {!isLoading && (receivables ?? []).length === 0 && (
          <div className="text-secondary" style={{ fontSize: "0.85rem" }}>
            Nenhum título encontrado.
          </div>
        )}
        <div className="d-flex flex-column gap-2">
          {(receivables ?? []).map((r) => (
            <div
              key={r.id}
              className="d-flex align-items-center gap-3 pb-2"
              style={{ fontSize: "0.9rem", borderBottom: "1px solid var(--color-divider)" }}
            >
              <span className="flex-grow-1">{r.reference}</span>
              <span className="nt-tabular text-secondary">{formatDate(r.dueDate)}</span>
              <span className="nt-tabular" style={{ fontWeight: 700 }}>
                {formatBRL(r.value)}
              </span>
              <StatusTag status={r.status} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
